import { Injectable } from '@angular/core';
import { MigrationUser } from '../model/migration-user';
import { Observable , of} from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { retryStrategy, api } from '../../shared/api-loaders';
import { retryWhen } from 'rxjs/operators';
import { RolesDisciplines, UserDetailOptionsRole } from '../../users/models/user-detail-options';
import { SnfImportResult } from '../model/SnfImportResult';
import { Transaction, TransactionFailedRecord } from '../model/Transaction';
import { SnfLegacyImportData } from '../model/SnfLegacyImportData';

@Injectable({
  providedIn: 'root'
})
export class SnfLegacyMigrationService {




  constructor(private http: HttpClient) {
  }

    public getTransactions() {
        return this.http.get<Transaction[]>(api.snfUsersImportTransactions()).pipe(
            retryWhen(retryStrategy()));
    }
    public getFailedUsers(processId) {
        return this.http.get<TransactionFailedRecord[]>(api.snfUsersImportFailedUsers(processId)).pipe(
            retryWhen(retryStrategy()));
    }

  import(data: SnfLegacyImportData ) {
    return this.http.post(api.snfUsersImport(), data).pipe(
      retryWhen(retryStrategy()));
  }

  getReferenceData(crmId: string): Observable<RolesDisciplines[]> {
    var params = new HttpParams();
    params = params.set("crmId", crmId);
    return this.http.get<RolesDisciplines[]>(api.customerReferenceData(), { params: params  }).pipe(
      retryWhen(retryStrategy()));
  }
  getUsers(customer: number, environment: number, corporation: number, facilities: number[], templates: UserDetailOptionsRole[], includeSpecialUsers: boolean, includePhysicianNppaUsers: boolean): Observable<MigrationUser[]> {
    var params = new HttpParams();
    params = params.set("envId", environment.toString());
    params = params.set("corpId", corporation.toString());

    facilities = facilities || [];
    templates = templates || [];
    params = params.set("facilityIdList", facilities.toString());
    params = params.set("excludeTemplateIdList", templates.map(x => x.id).toString());
    params = params.set("includeSpecialUsers", includeSpecialUsers);
    params = params.set("includePhysicianNppaUsers", includePhysicianNppaUsers);

    return this.http.get<MigrationUser[]>(api.snfUsersToImport(), { params: params  }).pipe(
      retryWhen(retryStrategy()));

    }


}
